@if (screenLayoutService.phone$ | async) {
  <div copyright>
    <a title href="/portal/" target="_blank">Service Software Online (SeSO)</a>
    <span class="siemens-copy"
      >Siemens Healthineers AG &copy;{{ moment().year() }}</span
    >
    <a class="phone-privacy-link" href="{{ privacyLink }}" target="_blank">{{
      'label.privacyNotice' | translate
    }}</a>
    <a class="phone-privacy-link" href="{{ termsOfUse }}" target="_blank">{{
      'label.termsOfUse' | translate
    }}</a>
    <a
      class="phone-privacy-link"
      href="{{ termsOfUseChinese }}"
      (click)="openTermsOfUseChinese($event)"
      target="_blank"
      >{{ 'label.termsOfUseChinese' | translate }}</a
    >
  </div>
} @else {
  <div copyright>
    <div>
      <a title href="/portal/" target="_blank"
        >Service Software Online (SeSO)</a
      >
      &nbsp;&#x2022;&nbsp;
      <a href="{{ privacyLink }}" target="_blank"
        >{{ 'label.privacyNotice' | translate }}
      </a>
      &nbsp;&#x2022;&nbsp;
      <a href="{{ termsOfUse }}" target="_blank">{{
        'label.termsOfUse' | translate
      }}</a>
      &nbsp;&#x2022;&nbsp;
      <a
        href="{{ termsOfUseChinese }}"
        (click)="openTermsOfUseChinese($event)"
        target="_blank"
        >{{ 'label.termsOfUseChinese' | translate }}</a
      >
      &nbsp;&#x2022;&nbsp;
    </div>

    <span>Siemens Healthineers AG &copy;{{ moment().year() }}</span>
  </div>
}

<div feedback>
  <span title>We appreciate your feedback:</span>
  <span content>
    <sh-button
      id="contact-button"
      label="Contact us"
      icon="envelope"
      icon-position="left"
      size="max-content"
      [href]="
        configurationService.getPortalWebAppConfiguration()
          .seSOTeamMailAddress + '?subject=Feedback SeSO'
      "
    ></sh-button>
    <sh-button
      id="feedback-button"
      label="Feedback Form"
      icon="question"
      icon-position="left"
      size="max-content"
      (click)="openFeedbackForm()"
    ></sh-button
  ></span>
</div>

<div emissions>
  <svg xmlns="http://www.w3.org/2000/svg" width="100" viewBox="-60 -75 120 90">
    <filter id="outline">
      <feFlood id="outline-color" flood-color="#000000" result="base" />
      <feMorphology
        result="bigger"
        in="SourceGraphic"
        operator="dilate"
        radius="1"
      />
      <feColorMatrix
        result="mask"
        in="bigger"
        type="matrix"
        values="0 0 0 0 0
             0 0 0 0 0
             0 0 0 0 0
             0 0 0 1 0"
      />
      <feComposite result="drop" in="base" in2="mask" operator="in" />
      <feGaussianBlur result="blur" in="drop" stdDeviation="1" />
      <feBlend in="SourceGraphic" in2="blur" mode="normal" />
    </filter>

    <!-- Tree 1 -->
    <g transform="translate(-30, 0)">
      <!-- Tree trunk -->
      <rect x="-2" y="-30" width="4" height="30" fill="#8B4513" />
      <!-- Tree crown -->
      <circle cx="0" cy="-40" r="15" fill="#228B22" />
      <circle cx="5" cy="-30" r="10" fill="#228B22" />
      <circle cx="-5" cy="-30" r="10" fill="#228B22" />
    </g>

    <!-- Tree 3 -->
    <g transform="translate(30, 0)">
      <!-- Tree trunk -->
      <rect x="-2" y="-30" width="4" height="30" fill="#8B4513" />
      <!-- Tree crown -->
      <circle cx="0" cy="-40" r="15" fill="#228B22" />
      <circle cx="5" cy="-30" r="10" fill="#228B22" />
      <circle cx="-5" cy="-30" r="10" fill="#228B22" />
    </g>

    <!-- Tree 2 -->
    <g transform="scale(1.3), translate(0, 0)" filter="url(#outline)">
      <!-- Tree trunk -->
      <rect x="-2" y="-30" width="4" height="30" fill="#8B4513" />
      <!-- Tree crown -->
      <circle cx="0" cy="-40" r="15" fill="#228B22" />
      <circle cx="5" cy="-30" r="10" fill="#228B22" />
      <circle cx="-5" cy="-30" r="10" fill="#228B22" />
    </g>
  </svg>
  <div>
    <span title>CO<sub>2</sub> Emissions Saved:</span>
    <span><i>approx.</i> 234.234.5kg</span>
  </div>
</div>
